<template>
  <div>
    <div id="modalDetail">
      <div
        id="modal-idea-detail"
        class="modal fade show"
        tabindex="-1"
        role="dialog"
        style="display: block; background-color: rgba(0, 0, 0, 0.5)"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div class="modal-content" ref="modalContent">
            <div class="modal-header bg-blue-3 rounded-0">
              <h5 class="modal-title text-center text-white mx-auto">
                {{ modalTitle }}
              </h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="container mb-3 mw-100">
              <div class="row">
                <vue-good-table
                  class="admin-table"
                  :columns="columns"
                  :rows="continuityTrackingList"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'SuggestionNumber'">
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                    <div v-else-if="props.column.field == 'Detail'">
                      <div
                        v-b-tooltip.hover.bottom
                        :title="props.formattedRow[props.column.field]"
                      >
                        {{
                          props.formattedRow[props.column.field]
                            | truncateFilter
                        }}
                      </div>
                    </div>
                    <div v-else-if="props.column.field == 'action'">
                      <form id="updateSuggestionResultForm">
                        <input
                          name="__RequestVerificationToken"
                          type="hidden"
                          value="VBrI4HoiLXlnxE0_6rh2XqoVmlmwWYWKyPlQdVW-THoJxa40c7UcJv4nZZGeC8TmRAoXc1M-kVEQfQHpaDX8Y1RKIRmlIq3NVhstmPTTNKeTK_l9STrVxt7Wxm5GPn79EoPf-brb-TnE_gq9ps4R8A2"
                        />
                        <input
                          data-val="true"
                          data-val-required="The Id field is required."
                          id="Id"
                          name="Id"
                          type="hidden"
                          value="b6574625-3b32-ec11-b6e6-000d3adab7a4"
                        />
                        <div class="form-group icon-down">
                          <select
                            class="form-control"
                            id="ContinuityTrackingEvaluatorNote"
                            :name="`${props.row.Id}`"
                            validationelement="1"
                            v-model="
                              contTrackingList.find(
                                (x) => x.SuggestionId == props.row.Id
                              ).EvaluatorNote
                            "
                          >
                            <option value="">Seçiniz...</option>
                            <option value="Uygulama devam ediyor">
                              Uygulama devam ediyor
                            </option>
                            <option value="Tek seferlik uygulamaydı">
                              Tek seferlik uygulamaydı
                            </option>
                            <option value="Devam etmiyor">Devam etmiyor</option>
                          </select>
                        </div>
                        <div
                          id="ContinuityTrackingEvaluatorNoteError"
                          class="form-group invalid-feedback"
                          :style="[
                            requiredField.includes(
                              `EvaluatorNote_${props.row.Id}`
                            )
                              ? { display: 'block' }
                              : '',
                          ]"
                        >
                          Bu alan boş geçilemez!
                        </div>
                        <div
                          class="form-group"
                          id="ContinuityTrackingEvaluatorReasonPanel"
                          v-if="
                            contTrackingList.find(
                              (x) => x.SuggestionId == props.row.Id
                            ).EvaluatorNote == 'Devam etmiyor'
                          "
                        >
                          <textarea
                            class="form-control short"
                            cols="20"
                            id="ContinuityTrackingEvaluatorReason"
                            maxlenght="2000"
                            :name="`EvaluatorReason_${props.row.Id}`"
                            placeholder="Açıklama..."
                            rows="2"
                            v-model="
                              contTrackingList.find(
                                (x) => x.SuggestionId == props.row.Id
                              ).EvaluatorReason
                            "
                          ></textarea>
                        </div>
                        <div
                          id="ContinuityTrackingEvaluatorReasonError"
                          class="form-group invalid-feedback"
                          :style="[
                            requiredField.includes(
                              `EvaluatorReason_${props.row.Id}`
                            )
                              ? { display: 'block' }
                              : '',
                          ]"
                        >
                          Bu alan boş bırakılamaz, karakter sayısını arttırarak
                          tekrar deneyiniz.
                        </div>
                      </form>
                    </div>
                  </template>
                </vue-good-table>
                <div
                  class="row mt-4 d-flex align-items-center justify-content-center w-100"
                >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRecords"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
              <div
                class="row text-right d-flex align-items-center justify-content-center"
              >
                <span class="text-black-50 font-weight-bold"
                  >Toplam: {{ totalRecords }} Adet</span
                >
                <button
                  type="button"
                  class="btn-innovation-radius bg-blue-1 Roboto-Bold ml-4 py-2 px-4"
                  @click="sendContinuityTrackingUpdate"
                >
                  GÖNDER
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="isExitmodal"
        id="Warning"
        class="modal fade show"
        style="height: 200px; display: block"
        role="dialog"
        data-backdrop="false"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <p>
                Kaydetmediğiniz satırlar mevcut çıkmak istediğinize emin
                misiniz?
              </p>
              <button
                type="button"
                class="btn btn-danger confirmclosed"
                style="margin-left: 27%"
                @click.stop="exitModal"
              >
                Çık
              </button>
              <button
                type="button"
                class="btn btn-primary ml-2"
                data-dismiss="modal"
                @click.stop="isExitmodal = false"
              >
                Devam Et
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  dateFormatter,
  getInitials,
  newDateFormatter,
  dateDiff,
  cancelReason,
  currentDateTime,
} from "../../helpers";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
export default {
  name: "ContinuityTrackingBulkModal",
  data() {
    return {
      modalTitle: "FİKİR SÜREKLİLİK TAKİBİ",
      isComment: false,
      isExitmodal: false,
      currentPage: 1,
      perPage: 10,
      columns: [
        {
          label: "Fikir No.",
          field: "SuggestionNumber",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
          width: "150px",
        },
        {
          label: "Detay",
          field: "Detail",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Süreklilik",
          field: "action",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
          width: "250px",
        },
      ],
      continuityTrackingEvaluatorNote: "",
      continuityTrackingEvaluatorReason: "",
      requiredField: [],
      contTrackingList: [],
      contRequestModel: {
        EvaluatorId: 0,
        CompanyId: 0,
        EvaluatedSuggestions: [],
      },
      minLengthForText: 4,
    };
  },
  components: {
    VueGoodTable,
  },
  props: {
    searchFilterData: {
      type: Object,
      default: () => {},
    },
    continuityTrackingList: {
      type: Array,
      default: () => [],
    },
    totalRecords: {
      type: Number,
    },
    title: {
      type: String,
    },
  },
  watch: {
    currentPage() {
      this.getPagedList();
    },
    continuityTrackingList() {
      this.setRequestModel();
    },
  },
  filters: {
    truncateFilter(value) {
      return value?.length > 40 ? `${value.slice(0, 20)} ...` : value;
    },
    dateFormatterFilter(value) {
      return dateFormatter(value);
    },
    dateDiffFilter(value) {
      return dateDiff(value);
    },
    newDateFormatterFilter(value) {
      return newDateFormatter(value);
    },
    getInitialsFilter(value) {
      return getInitials(value);
    },
    cancelReasonFilter(value) {
      return cancelReason(value);
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
  },
  beforeMount() {
    document.addEventListener("click", this.clickOutSide);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickOutSide);
  },
  created() {
    const $body = document.querySelector("body");
    $body.style.overflow = "hidden";
    this.setRequestModel();
    if (this.title) this.modalTitle = this.title;
  },
  methods: {
    async getPagedList() {
      let tmpData = null;
      tmpData = {
        pageSize: this.perPage,
        pageIndex: parseInt(this.currentPage - 1),
        loginUserId: this.user.Data.UserId,
        isAdminPage: true,
        onlyContinuityTrackingSuggestion: true,
      };
      this.$emit("get-continuity-tracking-paged-list", tmpData);
    },
    setRequestModel() {
      if (this.continuityTrackingList.length > 0) {
        this.contTrackingList = [];
        this.continuityTrackingList.forEach((value) => {
          this.contTrackingList.push({
            SuggestionId: value.Id,
            EvaluatorNote: "",
            EvaluatorReason: "",
          });
        });
      }
    },
    getCurrentDateTime() {
      return currentDateTime();
    },
    onClearReturnValueDecider() {
      this.close();
    },
    onRemoveValueDecider() {
      this.close();
    },
    onClearValueDistributor() {
      this.close();
    },
    onRemoveValueDistributor() {
      this.close();
    },
    onClearReturnValue() {
      this.close();
    },
    onRemoveValue() {
      this.close();
    },
    exitModal() {
      this.isExitmodal = false;
      this.tmpShareData = null;
      this.$emit("close", false);
      const $body = document.querySelector("body");
      $body.style.removeProperty("overflow");
    },
    close({ isSaveEditBtn = false }) {
      if (!isSaveEditBtn && this.isOutsideClick()) {
        this.isExitmodal = true;
      } else {
        this.$emit("close", false);
        const $body = document.querySelector("body");
        $body.style.removeProperty("overflow");
      }
    },
    clickOutSide(e) {
      let el = this.$refs.modalContent;
      let target = e.target;
      if (el !== target && !el.contains(target)) {
        if (this.tmpShareData) {
          this.isExitmodal = true;
        } else {
          this.close({ isSaveEditBtn: false });
        }
      }
    },
    isOutsideClick() {
      if (
        this.contTrackingList.find(
          (x) => x.EvaluatorNote && x.EvaluatorNote.length > 0
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async sendContinuityTrackingUpdate() {
      this.requiredField = [];
      let isValid = true;
      if (this.contTrackingList.filter((x) => x.EvaluatorNote).length > 0) {
        this.contRequestModel.EvaluatedSuggestions =
          this.contTrackingList.filter((x) => x.EvaluatorNote);
        this.contRequestModel.EvaluatedSuggestions.forEach((item) => {
          if (
            item.EvaluatorNote == "Devam etmiyor" &&
            (!item.EvaluatorReason ||
              item.EvaluatorReason.trim().length <= this.minLengthForText)
          ) {
            isValid = false;
            this.requiredField.push(`EvaluatorReason_${item.SuggestionId}`);
          }
        });
      } else {
        isValid = false;
      }

      if (isValid) {
        this.contRequestModel.EvaluatorId = this.user.Data.UserId;
        this.contRequestModel.CompanyId = this.user.Data.CompanyId;
        this.$emit("save-continuity-tracking-bulk", this.contRequestModel);
      } else {
        this.$toast.error("Lütfen zorunlu alanları doldurunuz!.", {
          position: "top",
        });
      }
    },
  },
};
</script>

<style>
.modal-content .tooltip-inner {
  max-width: 300px !important;
}
</style>
